import axios from 'axios';

const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;
const CHUNK_SIZE = 1.5 * 1024 * 1024;

export async function uploadMediaFile(file, adminToken, onProgress) {
  const init = await axios.post(
    `${API_URL}/admin/media/upload/init`,
    { filename: file.name, content_type: file.type, total_size: file.size },
    { params: { admin_token: adminToken } }
  );
  const uploadId = init.data.upload_id;
  const totalChunks = Math.max(1, Math.ceil(file.size / CHUNK_SIZE));
  for (let i = 0; i < totalChunks; i++) {
    const fd = new FormData();
    fd.append('upload_id', uploadId);
    fd.append('chunk_index', i);
    fd.append('chunk', file.slice(i * CHUNK_SIZE, (i + 1) * CHUNK_SIZE));
    await axios.post(`${API_URL}/admin/media/upload/chunk`, fd, { params: { admin_token: adminToken } });
    if (onProgress) onProgress(Math.round(((i + 1) / totalChunks) * 90));
  }
  const done = await axios.post(`${API_URL}/admin/media/upload/complete`, { upload_id: uploadId }, { params: { admin_token: adminToken } });
  if (onProgress) onProgress(100);
  return done.data.media;
}
